import { CommonModule } from '@angular/common';
import { Component, NgModule, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ValidationCallbackData } from 'devextreme-angular/common';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { Subscription } from 'rxjs';
import { AuthService, IResponse } from 'src/app/services';

const notificationText = 'Sikeresen beállítottuk új jelszavát.';

@Component({
	selector: 'create-password-form',
	templateUrl: './create-password-form.component.html',
	styleUrls: ['./create-password-form.component.scss'],
})
export class CreatePasswordFormComponent implements OnInit {
	@Input() signInLink = '/auth/login';

	@Input() buttonLink = '/auth/login';

	loading = false;

	formData: any = {};
	private _paramMapSubscription: Subscription;
	private _recoveryCode: string;

	constructor(
		private authService: AuthService, 
		private router: Router,
		private route: ActivatedRoute
	) { 
		this._recoveryCode = '';
	}

	async ngOnInit(): Promise<void> {
		this._paramMapSubscription = this.route.paramMap.subscribe((params) => {
			this._recoveryCode = params.get('recoveryCode') || '';
		});
	}

	ngOnDestroy(): void {
		this._paramMapSubscription.unsubscribe();
	}

	async onSubmit(e: Event) {
		e.preventDefault();

		const { password } = this.formData;

		console.log('recoverycode, password', this._recoveryCode, password);
		
		this.loading = true;
		const result = await this.authService.createPassword(
			this._recoveryCode, 
			password);
		this.loading = false;

		if (result.isOk) {
			this.router.navigate([this.buttonLink]);
			notify(notificationText, 'success', 2500);
		} else {
			notify(result.message, 'error', 2000);
		}
	}

	confirmPassword = (e: ValidationCallbackData) => e.value === this.formData.password;
}
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		DxFormModule,
		DxLoadIndicatorModule,
	],
	declarations: [CreatePasswordFormComponent],
	exports: [CreatePasswordFormComponent],
})
export class CreatePasswordFormModule { }
